import { Identifier, randomUUID } from "../core";
export class PModifierInstanceId extends Identifier {
    constructor() {
        super("PModifierInstanceId", randomUUID());
    }
}
